import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Controller, useForm } from 'react-hook-form';
import { Box, Chip, Stack, TextField, Typography } from '@mui/material';
import { useDevice } from '../../hooks/useResponsive';

function EstimateCard({ selectedCurtain }) {
  const [curtainPrice, setCurtainPrice] = useState(selectedCurtain?.price_per_sqft);
  const [selectedSize, setSelectedSize] = useState(null);
  const [showCalculateButton, setShowCalculateButton] = useState(false);
  const { isMobile } = useDevice();

  useEffect(() => {
    if (selectedSize && selectedSize.width && selectedSize.height) {
      const widthM = Number(selectedSize.width) / 100;
      const heightM = Number(selectedSize.height) / 100;
      setCurtainPrice(widthM * heightM * (Number(selectedCurtain?.price_per_sqft) || 0));
    } else {
      setCurtainPrice(Number(selectedCurtain?.price_per_sqft) || 0);
    }
  }, [selectedCurtain, selectedSize]);

  const { control, watch, getValues, setValue } = useForm({
    defaultValues: {
      // height: 100,
      // width: 100,
    },
  });
  const height = watch('height');
  const width = watch('width');

  localStorage.setItem('height', height);
  localStorage.setItem('width', width);

  const convertCmToMeter = (value) => value / 100;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleCalculate = () => {
    // eslint-disable-next-line no-shadow
    const { height, width } = getValues();

    // Store values in localStorage if needed
    localStorage.setItem('height', height);
    localStorage.setItem('width', width);

    const widthM = convertCmToMeter(Number(width));
    const heightM = convertCmToMeter(Number(height));

    const newPrice = widthM * heightM * selectedCurtain?.price_per_sqft;
    setCurtainPrice(newPrice);
  };
  const handleCalculateCalculate = () => {
    const { heightInput, widthInput } = getValues();

    // Store values in localStorage if needed
    localStorage.setItem('height', height);
    localStorage.setItem('width', width);

    const widthM = convertCmToMeter(Number(widthInput));
    const heightM = convertCmToMeter(Number(heightInput));

    const newPrice = widthM * heightM * selectedCurtain?.price_per_sqft;
    // console.log(newPrice)
    setCurtainPrice(newPrice);
  };

  const handleChipSelect = useCallback(
    (size) => {
      setValue('width', size.width);
      setValue('height', size.height);
      handleCalculate();
      setSelectedSize(size);
    },
    [setValue, handleCalculate, setSelectedSize]
  );

  const handleManualInput = () => {
    // setIsManualInput((prev) => ({ ...prev, [fieldName]: true }));
    setSelectedSize(null); // Reset chip selection on manual input focus
    setShowCalculateButton(true);
  };

  return (
    <form>
      <Stack display="flex" flexDirection="column" gap={isMobile ? '5px' : '4px'} mx="10px" alignItems="flex-start">
        <Typography fontSize="14px" className="roboto-sans-light-bold">
          Custom Size
        </Typography>

        <Stack className='calculationEstimate'
          direction="row"
          spacing={2}
          width="100%"
          // sx={{
          //   width: {
          //     xs: '100%', // 👈 hidden on extra-small (below 600px)
          //     md: '100%', // 👈 shown on small and up (>=600px)
          //   },
          // }}
        >
          <Box flex={1}>
            <Controller
              name="heightInput"
              control={control}
              rules={{ required: 'Height is required', min: 1 }}
              render={({ field }) => (
                <TextField
                  {...field}
                  onFocus={() => handleManualInput('height')}
                  placeholder="Height in cm"
                  type="number"
                  variant="outlined"
                  size="small"
                  inputProps={{ min: 1 }}
                  className="product-measurement-input"
                  fullWidth
                  sx={{
                    border: `1px solid #989fb4`,
                    borderRadius: '8px',
                    '& .MuiOutlinedInput-root': {
                      height: '39px',
                    },
                    '& .MuiInputBase-input': {
                      ml: '12px',

                      fontSize: '16px',
                      padding: '0',
                    },
                    '& .MuiInputBase-input::placeholder': {
                      // paddingLeft:'10px',
                      fontSize: '12px',
                      width: '100px',
                    },
                  }}
                />
              )}
            />
          </Box>

          <Box flex={1}>
            <Controller
              name="widthInput"
              control={control}
              rules={{ required: 'Width is required', min: 1 }}
              render={({ field }) => (
                <TextField
                  {...field}
                  onFocus={() => handleManualInput('width')}
                  placeholder="Width in cm"
                  type="number"
                  variant="outlined"
                  size="small"
                  inputProps={{ min: 1 }}
                  className="product-measurement-input"
                  fullWidth
                  sx={{
                    border: `1px solid #989fb4`,
                    borderRadius: '8px',
                    '& .MuiOutlinedInput-root': {
                      height: '39px',
                      ml: '12px',
                    },
                    '& .MuiInputBase-input': {
                      fontSize: '16px',
                      padding: '0',
                    },
                    '& .MuiInputBase-input::placeholder': {
                      // paddingLeft:'10px',
                      fontSize: '12px',
                      width: '100px',
                    },
                  }}
                />
              )}
            />
          </Box>
          {showCalculateButton && (
            <Box
              component="button"
              onClick={handleCalculateCalculate}
              className="roboto-sans-light-bold"
              type="button"
              sx={{
                // display: {
                //   xs: 'none', // 👈 hidden on extra-small (below 600px)
                //   sm: 'block', // 👈 shown on small and up (>=600px)
                // },
                bgcolor: '#EB1C24',
                color: 'white',
                border: 'none',
                px: 3,
                fontSize: '14px',
                fontWeight: 600,
                borderRadius: '8px',
                height: '42px',
                minWidth: '100px',
                cursor: 'pointer',
                '&:hover': {
                  bgcolor: '#c4161d',
                },
              }}
            >
              Calculate
            </Box>
          )}
        </Stack>
      </Stack>

      <Stack direction="column" gap={isMobile ? '5px' : '2px'} px={1} mt={isMobile ? 2 : 1}>
        <Box minWidth="80px">
          <Typography fontSize="14px" className="roboto-sans-light-bold" lineHeight={1.4}>
            Regular Size
          </Typography>
        </Box>

        <ChipsSwiper
          onSelectSize={handleChipSelect}
          selectedSize={selectedSize}
          height={height}
          width={width}
          setValue={setValue}
          setSelectedSize={setSelectedSize}
          selectedCurtain={selectedCurtain}
          setCurtainPrice={setCurtainPrice}
        />
      </Stack>

      {/* <Stack width={'100%'} direction={'row'} alignItems={'center'} my={3} justifyContent={'space-between'}>
          <Typography fontSize={isMobile ? '14px' : '22px'} color={colors.primary}>
            Estimate*&nbsp;&nbsp;:
          </Typography>
          <Typography fontWeight={800} color={colors.black} fontSize={isMobile ? '30px' : '38px'}>
            AED {curtainPrice.toFixed(2)}
          </Typography>
        </Stack> */}
      <Box
        sx={{
          borderRadius: 2,
          p: 2,
          pb: isMobile && 0,
          maxWidth: '100%',
          fontFamily: 'Roboto, sans-serif',
        }}
      >
        {/* Price Section */}
        <Stack spacing={isMobile?1:.5}>
          <Typography className="roboto-sans-regular" variant="subtitle2" color="text.secondary">
            AED <s> {curtainPrice ? curtainPrice.toFixed(2) : '000.00'}</s>{' '}
            <Typography
              letterSpacing={1.5}
              className="roboto-sans-bold"
              variant="subtitle2"
              component="span"
              color="black"
            >
              AED{' '}
            </Typography>
            <Typography
              className="roboto-sans-bold"
              variant="h6"
              component="span"
              color="black"
              letterSpacing={1.5}
            >
              {curtainPrice
                ? (curtainPrice - (curtainPrice * (selectedCurtain?.offer_percentage || 0)) / 100).toFixed(2)
                : '000.00'}{' '}
            </Typography>{' '}
            <Typography
              letterSpacing={1}
              component="span"
              color="green"
              className="roboto-sans-bold"
              variant="caption"
            >
              {selectedCurtain?.offer_percentage}% off
            </Typography>
          </Typography>

          {/* EMI/month */}
          <Typography className="roboto-sans-regular" variant="subtitle2">
            or{' '}
            <Typography className="roboto-sans-bold" variant="h6" component="span" sx={{ color: 'green' }}>
              AED
            </Typography>{' '}
            <Typography
              className="roboto-sans-bold"
              variant="h6"
              letterSpacing={1.5}
              component="span"
              sx={{ color: 'green' }}
            >
              {/* {(curtainPrice / 3).toFixed(2)}/month */}
              {curtainPrice ? (curtainPrice / 3).toFixed(2) : '000.00'}/month
            </Typography>{' '}
            <Typography
              className="roboto-sans-regular"
              variant="subtitle2"
              component="span"
              color="text.secondary"
              fontSize="14px"
            >
              (for 3 months)
            </Typography>
          </Typography>

          {/* EMI Chip */}
          <Chip
            label="EMI Available"
            size="small"
            sx={{
              backgroundColor: '#E6F0E6',
              color: '#black',
              fontSize: '12px',
              width: 'fit-content',
              borderRadius: '0px',
            }}
          />
        </Stack>
      </Box>
    </form>
  );
}

export default EstimateCard;

EstimateCard.propTypes = {
  selectedCurtain: PropTypes.any,
};
function ChipsSwiper({ onSelectSize, selectedSize, setValue, setCurtainPrice, setSelectedSize, selectedCurtain }) {
  const handleChipSelect = useCallback(
    (size) => {
      setValue('width', size.width);
      setValue('height', size.height);

      const widthM = size.width / 100;
      const heightM = size.height / 100;
      const newPrice = widthM * heightM * selectedCurtain?.price_per_sqft;
      setCurtainPrice(newPrice);
      setSelectedSize(size);
    },
    [selectedCurtain, setValue, setCurtainPrice, setSelectedSize]
  );

  const didSetDefault = useRef(false);
  useEffect(() => {
    if (!didSetDefault.current && selectedCurtain?.standard_items?.length > 0) {
      handleChipSelect(selectedCurtain.standard_items[0]);
      didSetDefault.current = true;
    }
  }, [handleChipSelect, selectedCurtain]);

  // useEffect(() => {
  //   if (!didSetDefault.current && sizeData.length > 0) {
  //     handleChipSelect(sizeData[0]);
  //     didSetDefault.current = true;
  //   }
  // }, [handleChipSelect, sizeData]);

  return (
    <Box
      sx={{
        display: 'flex',
        overflowX: 'auto',
        gap: 1,
        py: 0.5,
        '&::-webkit-scrollbar': { display: 'none' },
        scrollbarWidth: 'none', // Firefox
      }}
    >
      {selectedCurtain?.standard_items?.map((size, index) => {
        const isSelected = selectedSize?.width === size.width && selectedSize?.height === size.height;

        // const isSelected = selectedSize
        //   ? selectedSize.width === size.width && selectedSize.height === size.height
        //   : Number(height) === size.height && Number(width) === size.width;

        return (
          <Chip
            key={index}
            label={`${size.width} × ${size.height}`}
            onClick={() => onSelectSize(size)}
            color="primary"
            variant="outlined"
            sx={{
              flexShrink: 0,
              backgroundColor: isSelected ? '#fef8f9' : 'white',
              borderColor: isSelected ? '#ED262980' : '#989fb4',
              color: isSelected ? 'rgba(0, 0, 0, 0.6)' : '#989fb4',
              px: 1,
              fontSize: '14px',
              borderRadius: '8px',
              '&:hover': !isSelected && {
                backgroundColor: '#fef8f9',
                borderColor: '#ED262980',
                color: 'rgba(0, 0, 0, 0.6)',
              },
            }}
          />
        );
      })}
    </Box>
  );
}
ChipsSwiper.propTypes = {
  onSelectSize: PropTypes.func.isRequired,
  selectedSize: PropTypes.object,
  // height: PropTypes.any,
  // width: PropTypes.any,
  setValue: PropTypes.any,
  setSelectedSize: PropTypes.any,
  setCurtainPrice: PropTypes.any,
  selectedCurtain: PropTypes.any,
};
